/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface SolrPublisher
 */
export interface SolrPublisher  {
    /**
     * 
     * @type {string}
     * @memberof SolrPublisher
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SolrPublisher
     */
    name?: string;
}

/**
 * Check if a given object implements the SolrPublisher interface.
 */
export function instanceOfSolrPublisher(value: object): value is SolrPublisher {
    return true;
}

export function SolrPublisherFromJSON(json: any): SolrPublisher {
    return SolrPublisherFromJSONTyped(json, false);
}

export function SolrPublisherFromJSONTyped(json: any, ignoreDiscriminator: boolean): SolrPublisher {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'name': json['name'] == null ? undefined : json['name'],
    };
}

export function SolrPublisherToJSON(json: any): SolrPublisher {
    return SolrPublisherToJSONTyped(json, false);
}

export function SolrPublisherToJSONTyped(value?: SolrPublisher | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}


